import React from "react";
import { Button } from "../button/button";
// import person from '../../assets/icons/worker.svg';
// import person2 from '../../assets/hello-text/1.mp4'
import person3 from '../../assets/hello-text/1.webm'

import './hello-text.css';

export class HelloText extends React.Component {
  render() {
    return (
      <div className="hello-text">
        <div className="hello-text__person">
          <video id="hello-video" muted>
            {/* <source src={person2} type="video/gif" /> */}
            <source src={person3} type='video/webm'/>
            {/* <source src={person2} type = 'video/mp4'/> */}
            
              Your browser does not support the video tag.
            </video>
        </div>

        {/* <div className="hello-text__text">
          Привет! Меня зовут Тимур, я приехал из Узбекистана.<br />
          Помоги мне пройти все уровни, ответив правильно на все вопросы в разных ситуациях.
                </div> */}
        {/* <div className="hello-text__begin-button"> */}
        <Button text={this.props.text} status={this.props.status} onClick={this.props.onClick} />
        {/* </div> */}
      </div>
    );
  }
}
